// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__whAQ1","header":"ReportDetails_header__xbjQ4","title":"ReportDetails_title__Fcnr3","left":"ReportDetails_left__47ltd"};